import apiClient from './apiClient';
const URL = process.env.REACT_APP_API_URL + "/estados-instancias";

export const getEstadosInstancia = async () => {
    try {
        const response = await apiClient(URL, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        });
        const data = await response.json();
        if(response.status !== 200) {
            throw new Error("No se encontraron las áreas");
        }
        
        return data
    } catch (error) {
        throw error
    }
}
